var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 4.3,
    stroke: "#787878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6113 17.3008H8.99805V16.4863L11.2891 14.1602C11.7148 13.7305 12.0723 13.3477 12.3613 13.0117C12.6543 12.6758 12.877 12.3457 13.0293 12.0215C13.1816 11.6934 13.2578 11.334 13.2578 10.9434C13.2578 10.459 13.1133 10.0898 12.8242 9.83594C12.5391 9.57812 12.1621 9.44922 11.6934 9.44922C11.2832 9.44922 10.9199 9.51953 10.6035 9.66016C10.2871 9.80078 9.96289 10 9.63086 10.2578L9.10938 9.60156C9.33594 9.41016 9.58203 9.24023 9.84766 9.0918C10.1172 8.94336 10.4043 8.82617 10.709 8.74023C11.0176 8.6543 11.3457 8.61133 11.6934 8.61133C12.2207 8.61133 12.6758 8.70312 13.0586 8.88672C13.4414 9.07031 13.7363 9.33203 13.9434 9.67188C14.1543 10.0117 14.2598 10.416 14.2598 10.8848C14.2598 11.3379 14.1699 11.7598 13.9902 12.1504C13.8105 12.5371 13.5586 12.9219 13.2344 13.3047C12.9102 13.6836 12.5312 14.0859 12.0977 14.5117L10.2344 16.3691V16.4102H14.6113V17.3008Z",
    fill: "#787878"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.528cf2bbee66da2d79bed127f8383530.svg";
export { ForwardRef as ReactComponent };